import "./SliderInfo.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { useRef } from "react";
import { baseUrl } from "../../../utils/apiData";

const SliderInfo = ({ dataList }) => {
  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };
  return (
    <section className="verticales p_bottom">
      <div className="content_wrap">
        <div className="title_navigation">
          <h2 className="wow fadeInUp">Verticals</h2>
          <div className="btns">
            <button type="button" onClick={handlePrev}>
              <FaAngleLeft />
            </button>
            <button type="button" onClick={handleNext}>
              <FaAngleRight />
            </button>
          </div>
        </div>
        <div className="swiper_wraper_sec">
          <Swiper
            spaceBetween={0}
            slidesPerView={3}
            loop={true} // Infinite loop
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            breakpoints={{
              // Responsive breakpoints
              1100: { slidesPerView: 3 },
              600: { slidesPerView: 2 },
              100: { slidesPerView: 1 },
            }}
          >
            {dataList?.map((data) => {
              return (
                <SwiperSlide key={data?._id}>
                  <a href={data?.link} target="_blank">
                    <div className="verticle_slide">
                      <div className="img_wrap">
                        <img
                          src={`${baseUrl}/${data?.image}`}
                          alt="Verticles"
                        />
                      </div>
                      <h4>
                        <b>{data?.title}</b>
                      </h4>
                      <p>{data?.content}</p>
                    </div>
                  </a>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default SliderInfo;
